import { render, staticRenderFns } from "./DocumentAttestationTransport.vue?vue&type=template&id=30fb7924&scoped=true"
import script from "./DocumentAttestationTransport.vue?vue&type=script&lang=js"
export * from "./DocumentAttestationTransport.vue?vue&type=script&lang=js"
import style0 from "./DocumentAttestationTransport.vue?vue&type=style&index=0&id=30fb7924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb7924",
  null
  
)

export default component.exports